export const mockContainers = [
  {
    id: "traefik-proxy",
    name: "traefik",
    displayName: "Traefik",
    displayIcon: "simple-icons:traefikproxy",
    status: "running",
    watcher: "local",
    stack: "networking",
    image: {
      id: "sha256:4a8e3d6f1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e",
      registry: {
        name: "hub",
        url: "https://index.docker.io/v1/",
      },
      name: "traefik",
      tag: {
        value: "v3.2.0",
        semver: true,
      },
      digest: {
        watch: false,
        value: "sha256:4a8e3d6f1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e",
      },
      architecture: "amd64",
      os: "linux",
      created: "2024-11-10T14:32:10.000Z",
    },
    result: {
      tag: "v3.3.1",
      digest: "sha256:9b8c7d6e5f4a3b2c1d0e9f8a7b6c5d4e3f2a1b0c9d8e7f6a5b4c3d2e1f0a9b8c",
      created: "2024-12-18T10:15:00.000Z",
      link: "https://github.com/traefik/traefik/releases/tag/v3.3.1",
    },
    updateAvailable: true,
    updateKind: {
      kind: "tag",
      localValue: "v3.2.0",
      remoteValue: "v3.3.1",
      semverDiff: "minor",
    },
    labels: {
      "com.docker.compose.project": "networking",
      "com.docker.compose.service": "traefik",
    },
    isOfficial: true,
    documentationUrl: "https://hub.docker.com/_/traefik",
    changelogUrl: "https://github.com/traefik/traefik/releases",
    upstreamUrl: "https://github.com/traefik/traefik",
    link: "https://hub.docker.com/_/traefik",
  },
  {
    id: "pihole-dns",
    name: "pihole",
    displayName: "Pi-hole",
    displayIcon: "simple-icons:pihole",
    status: "running",
    watcher: "local",
    stack: "networking",
    image: {
      id: "sha256:8f7e6d5c4b3a2f1e0d9c8b7a6f5e4d3c2b1a0f9e8d7c6b5a4f3e2d1c0b9a8f7e",
      registry: {
        name: "hub",
        url: "https://index.docker.io/v1/",
      },
      name: "pihole/pihole",
      tag: {
        value: "2024.07.0",
        semver: true,
      },
      digest: {
        watch: false,
        value: "sha256:8f7e6d5c4b3a2f1e0d9c8b7a6f5e4d3c2b1a0f9e8d7c6b5a4f3e2d1c0b9a8f7e",
      },
      architecture: "amd64",
      os: "linux",
      created: "2024-07-15T09:00:00.000Z",
    },
    result: {
      tag: "2024.12.1",
      digest: "sha256:1a2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b",
      created: "2024-12-05T16:20:00.000Z",
      link: "https://github.com/pi-hole/docker-pi-hole/releases/tag/2024.12.1",
    },
    updateAvailable: true,
    updateKind: {
      kind: "tag",
      localValue: "2024.07.0",
      remoteValue: "2024.12.1",
      semverDiff: "minor",
    },
    labels: {
      "com.docker.compose.project": "networking",
      "com.docker.compose.service": "pihole",
    },
    isOfficial: false,
    documentationUrl: "https://docs.pi-hole.net/",
    changelogUrl: "https://github.com/pi-hole/docker-pi-hole/releases",
    upstreamUrl: "https://github.com/pi-hole/docker-pi-hole",
    link: "https://docs.pi-hole.net/",
  },
  {
    id: "homeassistant-core",
    name: "homeassistant",
    displayName: "Home Assistant",
    displayIcon: "simple-icons:homeassistant",
    status: "running",
    watcher: "local",
    stack: "smarthome",
    image: {
      id: "sha256:2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c",
      registry: {
        name: "ghcr",
        url: "https://ghcr.io",
      },
      name: "home-assistant/home-assistant",
      tag: {
        value: "2024.11.2",
        semver: true,
      },
      digest: {
        watch: false,
        value: "sha256:2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c",
      },
      architecture: "amd64",
      os: "linux",
      created: "2024-11-18T12:00:00.000Z",
    },
    result: {
      tag: "2024.12.0",
      digest: "sha256:7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f",
      created: "2024-12-04T18:30:00.000Z",
      link: "https://github.com/home-assistant/core/releases/tag/2024.12.0",
    },
    updateAvailable: true,
    updateKind: {
      kind: "tag",
      localValue: "2024.11.2",
      remoteValue: "2024.12.0",
      semverDiff: "minor",
    },
    labels: {
      "com.docker.compose.project": "smarthome",
      "com.docker.compose.service": "homeassistant",
    },
    isOfficial: false,
    documentationUrl: "https://www.home-assistant.io/docs/",
    changelogUrl: "https://github.com/home-assistant/core/releases",
    upstreamUrl: "https://github.com/home-assistant/core",
    link: "https://www.home-assistant.io/docs/",
  },
  {
    id: "vaultwarden-server",
    name: "vaultwarden",
    displayName: "Vaultwarden",
    displayIcon: "simple-icons:bitwarden",
    status: "running",
    watcher: "local",
    stack: "security",
    image: {
      id: "sha256:3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d",
      registry: {
        name: "hub",
        url: "https://index.docker.io/v1/",
      },
      name: "vaultwarden/server",
      tag: {
        value: "1.32.7",
        semver: true,
      },
      digest: {
        watch: false,
        value: "sha256:3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d",
      },
      architecture: "amd64",
      os: "linux",
      created: "2024-10-25T08:00:00.000Z",
    },
    result: {
      tag: "1.33.0",
      digest: "sha256:6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f7a",
      created: "2024-12-12T14:45:00.000Z",
      link: "https://github.com/dani-garcia/vaultwarden/releases/tag/1.33.0",
    },
    updateAvailable: true,
    updateKind: {
      kind: "tag",
      localValue: "1.32.7",
      remoteValue: "1.33.0",
      semverDiff: "minor",
    },
    labels: {
      "com.docker.compose.project": "security",
      "com.docker.compose.service": "vaultwarden",
    },
    isOfficial: false,
    documentationUrl: "https://github.com/dani-garcia/vaultwarden/wiki",
    changelogUrl: "https://github.com/dani-garcia/vaultwarden/releases",
    upstreamUrl: "https://github.com/dani-garcia/vaultwarden",
    link: "https://github.com/dani-garcia/vaultwarden",
  },
  {
    id: "nextcloud-app",
    name: "nextcloud",
    displayName: "Nextcloud",
    displayIcon: "simple-icons:nextcloud",
    status: "running",
    watcher: "remote-vps",
    stack: "cloud",
    image: {
      id: "sha256:4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e",
      registry: {
        name: "hub",
        url: "https://index.docker.io/v1/",
      },
      name: "nextcloud",
      tag: {
        value: "30.0.4",
        semver: true,
      },
      digest: {
        watch: false,
        value: "sha256:4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e",
      },
      architecture: "amd64",
      os: "linux",
      created: "2024-11-20T11:00:00.000Z",
    },
    result: {
      tag: "30.0.5",
      digest: "sha256:5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f",
      created: "2024-12-19T09:15:00.000Z",
      link: "https://github.com/nextcloud/server/releases/tag/v30.0.5",
    },
    updateAvailable: true,
    updateKind: {
      kind: "tag",
      localValue: "30.0.4",
      remoteValue: "30.0.5",
      semverDiff: "patch",
    },
    labels: {
      "com.docker.compose.project": "cloud",
      "com.docker.compose.service": "nextcloud",
    },
    isOfficial: true,
    documentationUrl: "https://docs.nextcloud.com/",
    changelogUrl: "https://github.com/nextcloud/server/releases",
    upstreamUrl: "https://github.com/nextcloud/server",
    link: "https://docs.nextcloud.com/",
  },
  {
    id: "portainer-ce",
    name: "portainer",
    displayName: "Portainer CE",
    displayIcon: "simple-icons:portainer",
    status: "running",
    watcher: "local",
    stack: "management",
    image: {
      id: "sha256:5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f",
      registry: {
        name: "hub",
        url: "https://index.docker.io/v1/",
      },
      name: "portainer/portainer-ce",
      tag: {
        value: "2.21.5",
        semver: true,
      },
      digest: {
        watch: false,
        value: "sha256:5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f",
      },
      architecture: "amd64",
      os: "linux",
      created: "2024-10-10T15:00:00.000Z",
    },
    result: {
      tag: "2.27.0",
      digest: "sha256:6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f7a",
      created: "2024-12-10T12:00:00.000Z",
      link: "https://github.com/portainer/portainer/releases/tag/2.27.0",
    },
    updateAvailable: true,
    updateKind: {
      kind: "tag",
      localValue: "2.21.5",
      remoteValue: "2.27.0",
      semverDiff: "minor",
    },
    labels: {
      "com.docker.compose.project": "management",
      "com.docker.compose.service": "portainer",
    },
    isOfficial: false,
    documentationUrl: "https://docs.portainer.io/",
    changelogUrl: "https://github.com/portainer/portainer/releases",
    upstreamUrl: "https://github.com/portainer/portainer",
    link: "https://docs.portainer.io/",
  },
  {
    id: "jellyfin-media",
    name: "jellyfin",
    displayName: "Jellyfin",
    displayIcon: "simple-icons:jellyfin",
    status: "running",
    watcher: "local",
    stack: "media",
    image: {
      id: "sha256:7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f7a8b",
      registry: {
        name: "hub",
        url: "https://index.docker.io/v1/",
      },
      name: "jellyfin/jellyfin",
      tag: {
        value: "10.10.3",
        semver: true,
      },
      digest: {
        watch: false,
        value: "sha256:7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f7a8b",
      },
      architecture: "amd64",
      os: "linux",
      created: "2024-12-01T20:00:00.000Z",
    },
    result: {
      tag: "10.10.3",
      digest: "sha256:7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f7a8b",
      created: "2024-12-01T20:00:00.000Z",
    },
    updateAvailable: false,
    updateKind: {
      kind: "unknown",
    },
    labels: {
      "com.docker.compose.project": "media",
      "com.docker.compose.service": "jellyfin",
    },
  },
  {
    id: "uptime-kuma-mon",
    name: "uptime-kuma",
    displayName: "Uptime Kuma",
    displayIcon: "mdi:chart-timeline-variant",
    status: "running",
    watcher: "local",
    stack: "monitoring",
    image: {
      id: "sha256:8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f7a8b9c",
      registry: {
        name: "hub",
        url: "https://index.docker.io/v1/",
      },
      name: "louislam/uptime-kuma",
      tag: {
        value: "1.23.16",
        semver: true,
      },
      digest: {
        watch: false,
        value: "sha256:8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f7a8b9c",
      },
      architecture: "amd64",
      os: "linux",
      created: "2024-11-05T17:00:00.000Z",
    },
    result: {
      tag: "1.23.16",
      digest: "sha256:8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f7a8b9c",
      created: "2024-11-05T17:00:00.000Z",
    },
    updateAvailable: false,
    updateKind: {
      kind: "unknown",
    },
    labels: {
      "com.docker.compose.project": "monitoring",
      "com.docker.compose.service": "uptime-kuma",
    },
  },
  {
    id: "mosquitto-broker",
    name: "mosquitto",
    displayName: "Eclipse Mosquitto",
    displayIcon: "simple-icons:eclipsemosquitto",
    status: "running",
    watcher: "local",
    stack: "smarthome",
    image: {
      id: "sha256:9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f7a8b9c0d",
      registry: {
        name: "hub",
        url: "https://index.docker.io/v1/",
      },
      name: "eclipse-mosquitto",
      tag: {
        value: "2.0.20",
        semver: true,
      },
      digest: {
        watch: false,
        value: "sha256:9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f7a8b9c0d",
      },
      architecture: "amd64",
      os: "linux",
      created: "2024-11-12T10:00:00.000Z",
    },
    result: {
      tag: "2.0.20",
      digest: "sha256:9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f7a8b9c0d",
      created: "2024-11-12T10:00:00.000Z",
    },
    updateAvailable: false,
    updateKind: {
      kind: "unknown",
    },
    labels: {
      "com.docker.compose.project": "smarthome",
      "com.docker.compose.service": "mosquitto",
    },
  },
];
